"use strict";
import "./proposal_custom_fields/proposal_custom_fields";
import "./proposal_better_ux/map_reload";
import "./proposal_better_ux/find_my_location_button";
import "./proposal_better_ux/use_camera_button";
